module.exports = __webpack_public_path__ + "static/img/img_f.53181778.png";